import {
  deleteProductApi,
  listOfProductApi,
  viewBatchProductApi,
} from "Api/product";
import { BaseImageURL } from "Api/services";
import BaseButton from "Components/Base/BaseButton";
import BasePanel from "Components/Base/BasePanel";
import TableContainer from "Components/Base/BaseTable";
import DeleteModal from "Components/Base/DeleteModal";
import {
  checkStatusCodeSuccess,
  errorHandler,
  notFound,
  Search,
} from "Components/constants/Common";
import { ProductKey, ProductLabel } from "Components/constants/Product";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import onErrorImg from "../../assets/images/onError.jpg";
import { RiSearchLine } from "react-icons/ri";
import withRouter from "Components/Common/withRouter";
import { ROReturnLabels } from "Components/constants/ReturnRONPO";
import BaseModal from "Components/Base/BaseModal";
import { useFormik } from "formik";
import { NoLabel, YesLabel } from "Components/constants/Role";
import BaseInput from "Components/Base/BaseInput";
import { ProductfileUpload } from "Api/common";

const Product = () => {
  document.title = ProductLabel.ProductTitle;
  const navigate = useNavigate();
  const [productData, setProductData] = useState<Array<any>>([]);
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [customPageSize, setCustomPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [productSearchData, setProductSearchData] = useState<Array<any>>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [tableLoader, setTableLoader] = useState<boolean>(false);
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false);
  const [productId, setProductId] = useState<number>();
  const [varientId, setVarientId] = useState<number>();
  const [viewProductData, setViewProductData] = useState<any>([]);
  const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
  const [isDeleteModal, setIsDeleteModal] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<"Overview" | "History">(
    "Overview"
  );
  const [checkedItems, setCheckedItems] = useState<{ [key: number]: number[] }>(
    {}
  );
  const [isCheckedAll, setIsCheckedAll] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [pdfLoader, setPdfLoader] = useState<boolean>(false);
  const [productModal, setProductModal] = useState<boolean>(false);
  const [modalLoader, setModalLoader] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  let totalNumber = 0;

  const handleFetchSorting = (
    page: any,
    id: SetStateAction<string>,
    order: SetStateAction<string>
  ) => {
    setCurrentPage(page);
    setColumnName(id);
    setSortOrder(order);
  };
  const handleFetchData = (page: any) => {
    setCurrentPage(page);
  };
  const handleSearchValueChange = (value: any) => {
    if (value !== searchValue) {
      setCurrentPage(1);
      setSearchValue(value);
    }
  };
  const fetchProductData = () => {
    setTableLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      limit: customPageSize,
    };

    listOfProductApi(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          const positions = response?.data?.listOfProduct || [];

          const processedData = positions.map((item: any) => ({
            id: item["product.id"],
            product_code: item["product.product_code"],
            minimum_quantity: item["product.minimum_quantity"],
            variantId: item.id,
            batch_no: item["batch_no"] || notFound.nullData,
            quantity: item["quantity"],
            rate: item["rate"],
          }));

          setProductData(processedData);
          setTotalRecords(response?.data?.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);

          if (searchValue) {
            fetchSearchProductData();
          }
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setTableLoader(false);
      });
  };

  const fetchSearchProductData = () => {
    setTableLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      search: searchValue,
      limit: customPageSize,
    };
    listOfProductApi(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          const positions = response?.data?.listOfProduct || [];

          const processedData = positions.map((item: any) => ({
            id: item["product.id"],
            product_code: item["product.product_code"],
            minimum_quantity: item["product.minimum_quantity"],
            variantId: item.id,
            batch_no: item["batch_no"] || notFound.nullData,
            quantity: item["quantity"],
            rate: item["rate"],
          }));

          setProductSearchData(processedData);
          setTotalRecords(response?.data?.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
        }
      })
      .catch((error) => {
        setProductSearchData([]);
        return error;
      })
      .finally(() => {
        setTableLoader(false);
      });
  };
  useEffect(() => {
    if (searchValue) {
      fetchSearchProductData();
    } else {
      fetchProductData();
    }
  }, [currentPage, customPageSize, sortOrder, columnName, searchValue]);

  const handleCheckAll = (currentPage: number) => {
    const currentCheckedAll = isCheckedAll[currentPage] || false;
    setIsCheckedAll({
      ...isCheckedAll,
      [currentPage]: !currentCheckedAll,
    });

    const updatedCheckedItems = currentCheckedAll
      ? []
      : productData?.map((item) => item.id);
    setCheckedItems({
      ...checkedItems,
      [currentPage]: updatedCheckedItems,
    });
  };

  const handleCheckItem = (id: number, currentPage: number) => {
    const currentCheckedItems = checkedItems[currentPage] || [];
    const isAlreadyChecked = currentCheckedItems?.includes(id);
    const updatedCheckedItems = isAlreadyChecked
      ? currentCheckedItems?.filter((itemId: number) => itemId !== id)
      : [...currentCheckedItems, id];

    setCheckedItems({
      ...checkedItems,
      [currentPage]: updatedCheckedItems,
    });

    setIsCheckedAll({
      ...isCheckedAll,
      [currentPage]: updatedCheckedItems?.length === totalNumber,
    });
  };
  const resetModalState = () => {
    setProductModal(false);
    setSelectedFile(null);
    productForm.resetForm();
  };

  useEffect(() => {
    if (isCheckedAll[currentPage] && productData) {
      const allCandidateIds = productData?.map((item) => item.id);
      setCheckedItems({
        ...checkedItems,
        [currentPage]: allCandidateIds,
      });
    }
  }, [isCheckedAll, productData, currentPage]);

  const productColumns = useMemo(
    () => [
      {
        header: ProductLabel.ProductCode,
        accessorKey: ProductKey.ProductCode,
        cell: (cell: any) => {
          return (
            <span>
              {cell.row?.original?.product_code ?? notFound.nullData}
            </span>
          );
        },
        enableColumnFilter: false,
      },
      {
        header: ProductLabel.BatchNo,
        accessorKey: ProductKey.BatchNo,
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: ProductLabel.Quantity,
        accessorKey: ProductKey.Quantity,
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: ProductLabel.MinimumQuantity,
        accessorKey: ProductKey.MinimumQuantity,
        cell: (cell: any) => {
          return <span>{cell.row?.original?.minimum_quantity ?? notFound.nullData}</span>;
        },
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: ProductLabel.Rate,
        accessorKey: ProductKey.Rate,
        cell: (cell: any) => {
          return (
            <div className="list-group bg-none list-group-flush p-1">
              <span>
                <i className="mdi mdi-currency-rupee"></i>
                {cell.row?.original?.rate}
              </span>
            </div>
          );
        },
        enableSorting: true,
        enableColumnFilter: false,
      },
    ],
    []
  );

  const handleRowClick = (state: boolean, data: any) => {
    setIsPanelOpen(true);
    setProductId(data?.id);
    fetchViewProductData(data?.id, data?.variantId);
    setVarientId(data?.variantId);
  };

  const fetchViewProductData = (id: number, varientId: number) => {
    setLoader(true);
    viewBatchProductApi(Number(id), Number(varientId))
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          const productData = resp?.data;

          const updatedViewProductData = {
            id: productData.id,
            product_code: productData?.product_code || notFound.nullData,
            product_description:
              productData?.product_description || notFound.nullData,
            material: productData?.material
              ? productData.material.name
              : notFound.nullData,
            materialGroup: productData?.materialGroup
              ? productData.materialGroup.name
              : notFound.nullData,
            product_status: productData?.product_status || notFound.nullData,
            batch_no:
              productData?.productVariant[0]?.batch_no || notFound.nullData,
            quantity:
              productData?.productVariant[0]?.quantity || notFound.nullData,
            rate: productData?.productVariant[0]?.rate || 0,
            amount: productData?.productVariant[0]?.amount || 0,
            uom: productData?.uom || notFound.nullData,
            remark: productData?.remark || notFound.nullData,
            product_image:
              productData?.productImage?.length > 0
                ? productData.productImage
                : [notFound.nullData],
            manufacturer:
              productData?.productVariant[0]?.manufacturer?.name ||
              notFound.nullData,
            minimum_quantity: productData?.minimum_quantity || 0,
            rake_no: productData?.rake_no || notFound.nullData,
            specifications: productData?.specifications || notFound.nullData,
            material_group_description:
              productData?.material_group_description || notFound.nullData,
          };

          setViewProductData(updatedViewProductData);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const deleteProduct = (id: any) => {
    setDeleteLoader(true);
    deleteProductApi(id)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.StatusCodes)) {
          toast.success(resp?.data);
          setIsDeleteModal(false);
          setIsPanelOpen(false);
          fetchProductData();
        } else {
          toast.error(resp?.data);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      })
      .finally(() => {
        setDeleteLoader(false);
      });
  };

  const productForm = useFormik({
    initialValues: {
      file: null as File | null,
    },
    onSubmit: async (values) => {
      if (!selectedFile) {
        toast.error(ProductLabel.selectFileToUpload);
        return;
      }

      setModalLoader(true);
      const formData = new FormData();
      formData.append("file", selectedFile);

      try {
        const uploadResp = await ProductfileUpload(formData);
        if (checkStatusCodeSuccess(uploadResp?.statusCode)) {
          toast.success(uploadResp?.message);
          setProductModal(false);
          fetchProductData();
        } else {
          toast.error(uploadResp?.message);
        }
      } catch (error: any) {
        errorHandler(error);
      } finally {
        setModalLoader(false);
      }
    },
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel"
      ) {
        setSelectedFile(file);
        productForm.setFieldValue("file", file);
      } else {
        toast.error(ProductLabel.OnlyExcelAllowed);
        event.target.value = "";
        productForm.setFieldValue("file", null);
      }
    }
  };

  const ImageCarousel = ({
    images,
  }: {
    images: { product_image: string }[];
  }) => {
    const [startIndex, setStartIndex] = useState(0);
    const imagesToShow = 3;

    const next = () => {
      if (startIndex + imagesToShow < images?.length) {
        setStartIndex(startIndex + 1);
      }
    };

    const previous = () => {
      if (startIndex > 0) {
        setStartIndex(startIndex - 1);
      }
    };

    return (
      <div className="d-flex align-items-center">
        {startIndex > 0 && (
          <div className="mdi mdi-arrow-left" onClick={previous}></div>
        )}

        <div className="d-flex">
          {images
            ?.slice(startIndex, startIndex + imagesToShow)
            .map((image, index) => (
              <div key={index} className="card position-relative mx-1">
                <img
                  src={`${BaseImageURL}${image?.product_image}`}
                  alt={`img-${index}`}
                  className="img-fluid img-container"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = onErrorImg;
                  }}
                />
              </div>
            ))}
        </div>

        {startIndex + imagesToShow < images?.length && (
          <i className="mdi mdi-arrow-right" onClick={next}></i>
        )}
      </div>
    );
  };

  return (
    <div className="page-content">
      <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
        <span className="fs-4 d-flex gap-4">{ProductLabel.ProductTitle}</span>
        <div className="d-flex align-items-center gap-2">
          <span className="tooltip-container">
            <BaseButton className="btn btn-info" loader={pdfLoader}>
              <i
                className="mdi mdi-file-import-outline"
                onClick={() => setProductModal(true)}
              ></i>
              <span className="tooltip-text">{ROReturnLabels.import}</span>
            </BaseButton>
          </span>
          <BaseButton
            className="btn btn-success"
            onClick={() => navigate("/addProduct")}
            children={
              <>
                <i className="mdi mdi-plus" /> {ProductLabel.NewProduct}
              </>
            }
          />
        </div>
      </div>
      <div className="card py-2 px-4 overflow-x-auto">
        {tableLoader || productData?.length > 0 ? (
          <TableContainer
            customPageSize={customPageSize}
            setCustomPageSize={setCustomPageSize}
            isGlobalFilter={true}
            columns={productColumns}
            data={searchValue ? productSearchData : productData || []}
            tableClass="table bg-white"
            manualPagination={true}
            manualFiltering={true}
            tableLoader={tableLoader}
            hasManualPagination={true}
            SearchPlaceholder={Search}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            totalRecords={totalRecords}
            onSearch={handleSearchValueChange}
            totalNumberOfRows={totalNumberOfRows}
            fetchData={handleFetchData}
            fetchSortingData={handleFetchSorting}
            setDrawerOpen={handleRowClick}
          />
        ) : (
          <div className="py-4 text-center">
            <div>
              <span className="fs-1 text-success">
                <RiSearchLine />
              </span>
            </div>
            <div className="mt-4">
              <h5>{notFound.dataNotFound}</h5>
              <p className="text-muted">{notFound.thereIsNoDataFound}</p>
            </div>
          </div>
        )}
      </div>
      <BasePanel
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
        size="450px"
        position="end"
        loader={loader}
        headerButtons={
          <>
            <div className="d-flex justify-content-end gap-2">
              <BaseButton className="btn btn-light py-0 px-2">
                <i
                  className="mdi mdi-pencil-outline fs-4 text-dark cursor-pointer"
                  onClick={() =>
                    navigate(`/editproduct/${productId}/${varientId}`)
                  }
                ></i>
              </BaseButton>
              {/* delete future purpose */}
              {/* <BaseButton className="btn btn-light py-0 px-2">
                <i
                  className="mdi mdi-delete-outline fs-4 text-danger cursor-pointer"
                  onClick={() => setIsDeleteModal(true)}
                ></i>
              </BaseButton> */}
            </div>
          </>
        }
        title={ProductLabel.ViewProduct}
      >
        <div>
          <div className="container-fluid d-flex flex-column">
            <div className="d-flex gap-2 bottom-div mt-2">
              <div className="d-flex flex-row gap-2">
                {viewProductData?.productImage?.length <= 2 ? (
                  viewProductData?.productImage?.map(
                    (image: any, index: number) => (
                      <div className="" key={index}>
                        <div className="card position-relative">
                          <img
                            src={`${BaseImageURL}${image?.product_image}`}
                            alt={`img-${index}`}
                            className="img-fluid img-container"
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.onerror = null;
                              target.src = onErrorImg;
                            }}
                          />
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <ImageCarousel images={viewProductData?.productImage} />
                )}
              </div>
            </div>
          </div>
          <div className="offcanvas-body flex-grow-1">
            <div className="card-header-tabs">
              <div className="card-body bg-white">
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item" role="presentation">
                    <span
                      className={`nav-link ${
                        activeTab === ProductLabel.Overview ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Overview")}
                      role="button"
                    >
                      {ProductLabel.Overview}
                    </span>
                  </li>
                  {/* <li className="nav-item" role="presentation">
                    <span
                      className={`nav-link ${
                        activeTab === ProductLabel.History ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("History")}
                      role="button"
                    >
                      {ProductLabel.History}
                    </span>
                  </li> */}
                </ul>
                <div className="tab-content text-muted">
                  {activeTab === ProductLabel.Overview && (
                    <div>
                      <h5>{ProductLabel.PrimaryDetails}</h5>
                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.ProductCode}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.product_code}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.Quantity}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.quantity}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">
                          {ProductLabel.MinimumQuantity}
                        </div>
                        <div className="col-6 text-dark">
                          {viewProductData?.minimum_quantity}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.Rate}</div>
                        <div className="col-6 text-dark">
                          <i className="mdi mdi-currency-rupee"></i>
                          {viewProductData?.rate}
                        </div>
                      </div>
                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.Amount}</div>
                        <div className="col-6 text-dark">
                          <i className="mdi mdi-currency-rupee"></i>
                          {viewProductData?.amount}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.BatchNo}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.batch_no}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.Make}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.manufacturer}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.MaterialType}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.material}
                        </div>
                      </div>
                      <div className="row my-3">
                        <div className="col-6">
                          {ProductLabel.MaterialGroup}
                        </div>
                        <div className="col-6 text-dark">
                          {viewProductData?.materialGroup}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">
                          {ProductLabel.ProductDescription}
                        </div>
                        <div
                          className={
                            viewProductData?.product_description?.length > 35
                              ? `col-6 text-dark tooltip-container`
                              : `col-6 text-dark`
                          }
                        >
                          <span className="material-name">
                            {viewProductData?.product_description}
                          </span>
                          <div className="d-flex align-items-end text-truncate no-whitespace">
                            <span className="">
                              {viewProductData?.product_description?.length >
                              35 ? (
                                <span>
                                  {viewProductData?.product_description?.substring(
                                    0,
                                    35
                                  )}
                                  ...
                                </span>
                              ) : (
                                viewProductData?.product_description
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row my-3">
                        <div className="col-6">
                          {ProductLabel.MaterialGroupDescription}
                        </div>
                        <div
                          className={
                            viewProductData?.material_group_description
                              ?.length > 35
                              ? `col-6 text-dark tooltip-container`
                              : `col-6 text-dark`
                          }
                        >
                          <span className="material-name">
                            {viewProductData?.material_group_description}
                          </span>
                          <div className="d-flex align-items-end text-truncate no-whitespace">
                            <span className="">
                              {viewProductData?.material_group_description
                                ?.length > 35 ? (
                                <span>
                                  {viewProductData?.material_group_description?.substring(
                                    0,
                                    35
                                  )}
                                  ...
                                </span>
                              ) : (
                                viewProductData?.material_group_description
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row my-3">
                        <div className="col-6">
                          {ProductLabel.Specifications}
                        </div>
                        <div className="col-6 text-dark">
                          {viewProductData?.specifications}
                        </div>
                      </div>
                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.Condition}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.product_status}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.RakeNo}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.rake_no}
                        </div>
                      </div>

                      <div className="row my-3">
                        <div className="col-6">{ProductLabel.Remark}</div>
                        <div className="col-6 text-dark">
                          {viewProductData?.remark}
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === ProductLabel.History && (
                    <div>
                      <div className="row">
                        <div className="col-6">
                          <h6>{ProductLabel.Date}</h6>
                        </div>
                        <div className="col-6">
                          <h6 className="f-8">{ProductLabel.Details}</h6>
                        </div>
                      </div>
                      <div className="border-bottom mb-2"></div>
                      <div className="row">
                        <div className="col-6">
                          <div>{ProductLabel.DateDetails}</div>
                        </div>
                        <div className="col-6">
                          <div>{ProductLabel.CreatedDetails}</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BasePanel>

      <BaseModal
        open={productModal}
        toggle={() => {
          resetModalState();
        }}
        submit={() => productForm.handleSubmit()}
        title={ProductLabel.ImportProduct}
        closeLabel={NoLabel}
        submitLabel={YesLabel}
        closeLabelColor="danger"
        submitLabelColor="success"
        loader={modalLoader}
        size="sm"
      >
        <div className="form-group">
          <BaseInput
            required={true}
            label={ProductLabel.importExcelFile}
            accept=".xlsx,.xls"
            tooltip={true}
            tooltipIcon="help-circle-outline"
            tooltipIconColor="info"
            tooltipText={ProductLabel.OnlyExcelAllowed}
            name="file"
            type="file"
            onChange={(event) => handleFileChange(event)}
            handleBlur={productForm.handleBlur}
            error={productForm.errors.file}
            touched={productForm.touched.file}
          />
          <div className="mt-3">
            <a href="sample_file.xlsx" download="sample_file">
              <i className="mdi mdi-file-check me-1"></i>
              {ProductLabel.clickHereToSeeSampleFile}
            </a>
          </div>
        </div>
      </BaseModal>
      <DeleteModal
        btnLoader={Boolean(deleteLoader)}
        onCloseClick={() => setIsDeleteModal(!isDeleteModal)}
        onDeleteClick={() => deleteProduct(productId)}
        show={isDeleteModal}
      />
    </div>
  );
};

export default withRouter(Product);
